import PropTypes from "prop-types";

import React from "react";

import * as ROUTES from "../../constants/routes.js";

import "./style.scss";

/*
 *  Link:
 *      A link element for our custom router using the History API.
 *
 *      We need a custom router in order to use the History API when using
 *          with Gatsby's SSR build.  We use React's StaticRouter, rather than
 *          the usual BrowserRouter or the Gatsby-native Reach Router, to render
 *          the pages themselves, but then we use custom history listeners in
 *          the page's React component to manage page state.
 */
const Link = (props) => {
  const clickLink = (event) => {
    var newHistoryState = {};
    var newHistoryTitle = "";

    // document.documentElement.style.overflow = "hidden";
    // document.body.style.overflow = "hidden";

    if (typeof window !== `undefined`) {
      window.history.scrollRestoration = "manual";
    }

    if (props.to == ".back") {
      event.preventDefault();
      window.history.back();
    } else {
      if (event.metaKey == true) {
        //  "Command" key pressed during click.
        //      --> Allow opening link in new tab.
      } else if (props.target == "_blank") {
        // Also allow opening external links in a new tab
      } else if (props.to.includes("tel:")) {
        // Also allow tel: links
      } else {
        event.preventDefault();

        window.history.pushState(newHistoryState, newHistoryTitle, props.to);

        var popStateEvent = new PopStateEvent("popstate", {
          state: newHistoryState,
          // state: { scrollTop: 500 },
        });
        window.dispatchEvent(popStateEvent);
      }
    }
  };

  var adjustedTo = props.to;
  if (adjustedTo == ".back") adjustedTo = "";

  return (
    <a
      className={`Link ${props.className ?? ""}`}
      style={props.style ?? null}
      onClick={clickLink}
      href={adjustedTo}
      target={props.target}
    >
      {props.children}
    </a>
  );
};

Link.propTypes = {
  to: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  target: PropTypes.string,
};

// For redirects without using a Link component:
const redirectTo = (toPath) => {
  var newHistoryState = {};
  var newHistoryTitle = "";

  window.history.pushState(newHistoryState, newHistoryTitle, toPath);

  var popStateEvent = new PopStateEvent("popstate", {
    state: newHistoryState,
  });
  window.dispatchEvent(popStateEvent);
};

export default Link;

export { redirectTo };
